<div
  class="list-item hover dontgrow"
  [class.embedded-in-collapsible]="embeddedInCollapsible"
  [class.show-background]="showBackground"
  [class.force-dark]="forceDarkMode"
  [ngStyle]="{ 'margin-bottom': marginBottom }"
  [class.hover]="hoverState"
  [class.bottom-border]="includeBottomBorder"
>
  <div
    class="list-item-container"
    [class.align-top]="alignTop"
    [class.expanded]="collapsible && !collapsed"
    (keydown.enter)="itemClick($event); $event.stopPropagation()"
    (keydown.space)="itemClick($event); $event.stopPropagation()"
    (click)="itemClick($event); $event.stopPropagation()"
  >
    @if (collapsible) {
      <button class="collapse-icon">
        <fa-icon [icon]="collapsed ? 'chevron-right' : 'chevron-down'"></fa-icon>
      </button>
    }
    @if (showImage) {
      <img
        [src]="photo ? photo : './assets/images/default_avatar.jpg'"
        [ngStyle]="{ opacity: inactive ? '.3' : '1' }"
        class="item-image"
        [class.large]="largeImage"
        [class.round]="imageRound"
        [class.image-border]="imageBorder"
        [alt]="photoAlt || ''"
      />
    }
    @if (icon) {
      <fa-icon class="list-item-icon" [icon]="icon"></fa-icon>
    }
    <div class="main-data" (click)="itemClick($event); $event.stopPropagation()" tabindex="0" [attr.role]="href ? 'link' : 'button'">
      <div class="d-flex align-items-center">
        @if (showUnreadBadge) {
          <span class="unread-badge d-block m-r-5">
            <span class="sr-only">status unread</span>
          </span>
        }
        <span class="bold">{{ title }}</span>
      </div>
      @if (subDataHtml) {
        <div class="sub-data">
          <ng-container [ngTemplateOutlet]="subDataHtml"></ng-container>
        </div>
      }

      @if (subData && subData.length) {
        <span class="sub-data">
          @for (data of subData; track data) {
            <div class="muted" [innerHTML]="data"></div>
          }
        </span>
      }
      @if (metadata && metadata.length) {
        <div class="metadata">
          @for (data of metadata; track data) {
            <div class="tag">
              <span class="title" [ngStyle]="{ color: data.color ? data.color : '' }">{{ data.title }}</span>
              @if (!data.redirect) {
                <span class="value" [ngStyle]="{ color: data.color || data.valueColor ? data.color || data.valueColor : '' }">{{ data.value }}</span>
              }
              @if (data.redirect) {
                <a [routerLink]="data.redirect" target="_blank" rel="noopener noreferrer" class="value" [ngStyle]="{ color: data.color ? data.color : '' }" (click)="redirectClicked.emit()">
                  {{ data.value }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="right-data-buttons">
      <ng-container>
        <ng-content select=".button-content"></ng-content>
      </ng-container>

      @if (includeChevron) {
        <fa-icon aria-label="Select" icon="chevron-right" class="m-l-5" [ngbTooltip]="chevronTooltip" aria-hidden="true"></fa-icon>
      }
    </div>
  </div>
  @if (collapsible) {
    <div class="collapsible" [class.d-none]="collapsed">
      <ng-content select=".collapsible-content"></ng-content>
    </div>
  }
</div>
